import React, {Component} from 'react'
import {FastLayer, Image} from 'react-konva';
import './stage.css';

/** @class ImageLayer
 * Renders a positioned image on the stage.
 */
export default class ImageLayer extends Component {
  /** @constructor
    * Creates a new instance of ImageLayer
    * @prop {url} image - the image to display on stage
    * @prop {number} x - the horizontal position of the image on stage
    * @prop {number} y - the vertical position of the image on stage
    */
  constructor(props) {
    super(props);
    this.state = {
      image: null
    }
  }
  /** @method componentDidMount
    * Loads the image.
    */
  componentDidMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({image: image});
    }
    image.src = this.props.image;
  }
  /** @function
   * Renders the image.
   */
  render() {
    return (
      <FastLayer>
        <Image
          image={this.state.image}
          x={this.props.x}
          y={this.props.y}
          transformsEnabled="position"
          />
      </FastLayer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/stage/image-layer.js